import { Component, ViewChild } from '@angular/core'
import { RoutingService } from '@spartacus/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { catchError, take } from 'rxjs/operators'
import { EbFormComponent } from '../../../../form/components/form/eb-form.component'
import { EbFormConfig } from '../../../../form/interfaces/eb-form.interface'
import { EbRfpFormInterface } from '../../interfaces/eb-rfp.interface'
import { EbRfpFormConfigService } from '../../services/facades/eb-rfp-form-config.service'
import { EbRfpFormService } from '../../services/facades/eb-rfp-form.service'

@Component({
    selector: 'eb-rfp-form',
    templateUrl: './eb-rfp-form.component.html',
    styleUrls: ['./eb-rfp-form.component.scss'],
    standalone: false
})
export class EbRfpFormComponent {
  @ViewChild('formComponent') formComponent: EbFormComponent

  formConfig$: Observable<EbFormConfig>
  sending$ = new BehaviorSubject(false)

  constructor(
    protected rfpFormConfigService: EbRfpFormConfigService,
    protected rfpFormService: EbRfpFormService,
    protected routingService: RoutingService
  ) {
    this.formConfig$ = this.rfpFormConfigService.formConfig$
  }

  onSubmit(form: EbRfpFormInterface) {
    this.sending$.next(true)
    this.rfpFormService
      .send(form)
      .pipe(
        take(1),
        catchError(error => {
          this.sending$.next(false)
          this.formComponent.form.get('captcha').reset()
          return error
        })
      )
      .subscribe(() => {
        this.routingService.goByUrl('/formSubmissionThankYou')
      })
  }
}
